// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"bb3e5ca7","407":"97c26abc","541":"711adba6","774":"2f98c969"}[chunkId] + ".chunk.js";
};